<template>
  <div class="object-card">
    <h3>{{ objectCard.name }}</h3>
    <span class="object-card__last">
      {{
        $t("object_card_last", {
          user: objectCard.lastChanges.user,
          date: objectCard.lastChanges.date
        })
      }}
    </span>

    <el-form
      label-position="top"
      inline
      :model="card"
      :disabled="lock"
      v-loading="loading"
      class="object-card-form"
    >
      <el-form-item
        class="object-card-form__item_small"
        :label="$t('object_card_isn')"
      >
        <el-input v-model="card.id" readonly></el-input>
      </el-form-item>

      <el-form-item :label="$t('object_card_name')">
        <el-input
          class="show-word-limit-pad object-card-form__item"
          v-model="card.name"
          maxlength="500"
          show-word-limit
          :disabled="!isVirtual"
          @change="changeCard"
        ></el-input>
      </el-form-item>

      <el-form-item :label="$t('object_card_country')">
        <el-select
          class="object-card-form__item"
          v-model="card.countryId"
          :disabled="!isVirtual"
          clearable
          filterable
          @change="changeCard"
        >
          <el-option
            v-for="item in countries"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('object_card_city')">
        <el-select
          class="object-card-form__item"
          v-model="card.cityId"
          :disabled="!isVirtual"
          clearable
          filterable
          @change="changeCard"
        >
          <el-option
            v-for="item in cities"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item :label="$t('object_card_type')">
        <el-input
          class="object-card-form__item"
          v-model="card.type"
          disabled
        ></el-input>
      </el-form-item>
    </el-form>

    <el-checkbox
      class="object-card_block"
      :indeterminate="isIndeterminate"
      :disabled="disabledAllLanguages"
      v-model="checkAll"
      @change="changeLanguageAll"
    >
      {{ $t("object_card_all_lang") }}
    </el-checkbox>
    <el-checkbox-group
      v-model="card.langs"
      :disabled="lock"
      @change="changeLanguageGroup"
    >
      <el-checkbox
        v-for="lang in languages"
        :label="lang.id"
        :key="lang.id"
        :disabled="lang.disabled"
      >
        {{ lang.name }}
      </el-checkbox>
    </el-checkbox-group>
  </div>
</template>

<script>
export default {
  name: "ObjectCard",
  props: {
    objectCard: Object,
    languages: Array,
    countries: Array,
    cities: Array,
    isVirtual: Boolean,
    loading: Boolean,
    lock: Boolean
  },
  data() {
    return {
      checkAll: false,
      isIndeterminate: true,
      card: {
        id: 0,
        name: "",
        countryId: 0,
        cityId: 0,
        type: "",
        langs: []
      }
    };
  },
  components: {},
  computed: {
    disabledAllLanguages() {
      return !this.languages.some(langs => !langs.disabled) || this.lock;
    }
  },
  methods: {
    changeLanguageAll(val) {
      this.card.langs = val
        ? this.languages.filter(langs => !langs.disabled).map(langs => langs.id)
        : [];
      this.isIndeterminate = false;

      this.changeCard();
    },
    changeLanguageGroup(value) {
      let checkedCount = value.length;
      this.checkAll = checkedCount === this.languages.length;
      this.isIndeterminate =
        checkedCount > 0 && checkedCount < this.languages.length;

      this.changeCard();
    },
    setCard() {
      if (this.objectCard) {
        this.card.id = this.objectCard.id || 0;
        this.card.name = this.objectCard.name || "";
        this.card.countryId = this.objectCard.countryId || 0;
        this.card.cityId = this.objectCard.cityId || 0;
        this.card.type = this.objectCard.type || "";
        this.card.langs = this.objectCard.langs || [];
      }
    },
    changeCard() {
      if (!this.card.name) {
        this.card.name = this.objectCard.name;
        return false;
      }

      if (this.card.cityId !== this.objectCard.cityId) {
        let item = this.cities.find(c => c.id === this.card.cityId);
        if (item) {
          this.card.countryId = item.countryId;
        }
      }

      if (this.card.countryId !== this.objectCard.countryId) {
        this.card.cityId = 0;
      }

      return this.$emit("changeCard", this.card);
    }
  },
  mounted() {
    this.setCard();
  },
  watch: {
    objectCard: function () {
      this.setCard();
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/css/variables.scss";

.object-card {
  padding: $element_padding_on_top $element_padding_on_left;
  padding-bottom: $element_padding_on_bottom;
  position: relative;

  .object-card__last {
    position: absolute;
    right: 5px;
    top: 1px;
    font-size: $label_font_size;
    color: $secondary_color;
  }

  .object-card_block {
    display: block;
    margin: 5px 0;
  }

  .object-card-form__item_small {
    width: 100px;
  }

  .object-card-form__item {
    width: 194px;
  }
}
</style>
